<template>
<v-autocomplete
  v-model="select"
  :items="items"
  :loading="loading"
  :search-input.sync="search"
  hide-no-data
  no-filter
  return-object

  :menu-props="{ offsetY: true, fixed: true }"
  :label="$t('Standort')"
  :placeholder="placeholder"

  no-data-text="Keine passenden Orte gefunden"
  attach
  @change="change"
  filled

  clearable
></v-autocomplete>
</template>

<script>
import { GeocoderFactory } from "./Geocoder";

export default {
  name: "GeocoderAutocomplete",

  props: [
    "value",
    "placeholder",
    "hide-details"
  ],

  data() {
    return {
      loading: false,
      search: null,
      select: null,
      items: []
    };
  },

  created() {
    // Timer und Anfragezähler je Komponenteninstanz.
    this.timeout = null;
    this.searchId = 0;
    this.destroyed = false;
    this.geocoder = null;

    GeocoderFactory().then(geocoder => {
      if (!this.destroyed) {
        this.geocoder = geocoder;
      }
    });
  },

  beforeDestroy() {
    this.destroyed = true;
    this.reset(false);
  },

  watch: {
    search(val) {
      if (!val || !val.trim()) {
        this.reset(true);
        return;
      }

      if (val !== this.select && !(this.select && val === this.select.text)) {
        this.querySelections(val);
      }
    },

    value(val) {
      if (val) {
        this.select = val;
      }
    }
  },

  methods: {
    reset(clearItems) {
      this.searchId++;

      if (this.timeout != null) {
        clearTimeout(this.timeout);
        this.timeout = null;
      }

      if (this.geocoder) {
        this.geocoder.cancelAutocomplete();
      }

      this.loading = false;

      if (clearItems) {
        this.items = [];
      }
    },

    querySelections(value) {
      this.reset(false);

      if (!this.geocoder) {
        return;
      }

      const searchId = this.searchId;
      this.loading = true;

      this.timeout = setTimeout(() => {
        this.timeout = null;

        this.geocoder.autocomplete(value).then(items => {
          if (searchId !== this.searchId || this.destroyed || items === null) {
            return;
          }

          this.items = items.slice();
        }).finally(() => {
          if (searchId === this.searchId && !this.destroyed) {
            this.loading = false;
          }
        });
      }, 150);
    },

    change(o) {
      // Nach einer Auswahl verspätete Antworten verwerfen.
      this.reset(false);
      this.$emit("change", o);
    }
  }
};
</script>
